import { ApiService } from "./api.service";
export default class PayrollItemService extends ApiService {
  namespace = "payrollItem";
  icon = "GraphMoney";
  name = "Notes";
  favicon = "PieGraph";
  type = "";
  action = "action";
  Width = 900;
  DOMAIN = -17;
  singular = this.terminology.payroll.singular;
  plural = this.terminology.payroll.plural;
  vowel = this.terminology.payroll.vowel;
  constructor() {
    super("payroll-items");
  }
}
